var _defs, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path2, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEndtoEndEncryption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EndtoEndEncryption_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".EndtoEndEncryption_svg__cls-1{fill:none;stroke:#292d3b;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px}.EndtoEndEncryption_svg__cls-2{fill:#292d3b}.EndtoEndEncryption_svg__cls-3{fill:#6bc6c4;opacity:.47}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "EndtoEndEncryption_svg__cls-1",
    d: "M35.15 80.51A5.15 5.15 0 0030 85.66v41.27a5.15 5.15 0 005.15 5.16H231a5.15 5.15 0 005.15-5.16V85.66a5.15 5.15 0 00-5.15-5.15zm0 72.23a5.15 5.15 0 00-5.15 5.15v41.27a5.15 5.15 0 005.15 5.16H231a5.15 5.15 0 005.15-5.16v-41.27a5.15 5.15 0 00-5.15-5.16zm0 72.23a5.15 5.15 0 00-5.15 5.15v41.27a5.15 5.15 0 005.15 5.16H231a5.15 5.15 0 005.15-5.16v-41.27A5.15 5.15 0 00231 225z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 58.9,
    cy: 106.3,
    rx: 7.73,
    ry: 7.74
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 89.82,
    cy: 106.3,
    rx: 7.73,
    ry: 7.74
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 120.74,
    cy: 106.3,
    rx: 7.73,
    ry: 7.74
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 58.9,
    cy: 178.53,
    rx: 7.73,
    ry: 7.74
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 89.82,
    cy: 178.53,
    rx: 7.73,
    ry: 7.74
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 120.74,
    cy: 178.53,
    rx: 7.73,
    ry: 7.74
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 58.9,
    cy: 250.75,
    rx: 7.73,
    ry: 7.74
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 89.82,
    cy: 250.75,
    rx: 7.73,
    ry: 7.74
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 120.74,
    cy: 250.75,
    rx: 7.73,
    ry: 7.74
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "EndtoEndEncryption_svg__cls-1",
    d: "M269 80.51a5.15 5.15 0 00-5.15 5.16v41.27a5.15 5.15 0 005.15 5.16h195.85a5.15 5.15 0 005.15-5.16V85.66a5.15 5.15 0 00-5.15-5.16zm0 72.23a5.15 5.15 0 00-5.15 5.16v41.27a5.15 5.15 0 005.15 5.16h195.85a5.15 5.15 0 005.15-5.16v-41.28a5.15 5.15 0 00-5.15-5.16zm0 72.26a5.15 5.15 0 00-5.15 5.16v41.27a5.15 5.15 0 005.15 5.16h195.85a5.15 5.15 0 005.15-5.16v-41.31a5.15 5.15 0 00-5.15-5.16z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 292.75,
    cy: 106.3,
    rx: 7.73,
    ry: 7.74
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 323.67,
    cy: 106.3,
    rx: 7.73,
    ry: 7.74
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 354.59,
    cy: 106.3,
    rx: 7.73,
    ry: 7.74
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 292.75,
    cy: 178.53,
    rx: 7.73,
    ry: 7.74
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 323.67,
    cy: 178.53,
    rx: 7.73,
    ry: 7.74
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 354.59,
    cy: 178.53,
    rx: 7.73,
    ry: 7.74
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 292.75,
    cy: 250.75,
    rx: 7.73,
    ry: 7.74
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 323.67,
    cy: 250.75,
    rx: 7.73,
    ry: 7.74
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "EndtoEndEncryption_svg__cls-2",
    cx: 354.59,
    cy: 250.75,
    rx: 7.73,
    ry: 7.74
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "EndtoEndEncryption_svg__cls-1",
    d: "M294.82 364.45h71.28v-85.83M132.61 278.62v85.83h71.57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "EndtoEndEncryption_svg__cls-3",
    d: "M218 357.47h82.31a4 4 0 014 4v64.08a4 4 0 01-4 4H218a4 4 0 01-4-4v-64.11a4 4 0 014-3.97z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "EndtoEndEncryption_svg__cls-1",
    d: "M208 347.47h82.31a4 4 0 014 4v64.08a4 4 0 01-4 4H208a4 4 0 01-4-4v-64.11a4 4 0 014-3.97z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "EndtoEndEncryption_svg__cls-2",
    d: "M253.36 377.49a4.18 4.18 0 10-6.66 3.36v11.9a2.48 2.48 0 105 0v-11.9a4.17 4.17 0 001.66-3.36z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "EndtoEndEncryption_svg__cls-1",
    d: "M218.39 329.73a30.81 30.81 0 1161.6-1.38v1.38M218.39 329.71v17.76M279.98 329.71v17.76"
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgEndtoEndEncryption as ReactComponent };